const name = "Snippit"

export const config = {
  name,
  slogan: "Write once. Export snippets to every editor.",
  description:
    "Create, preview, and copy snippets for VS Code, Sublime Text, Atom, and Zed with live updates.",
  keywords: ["snippets", "vscode", "sublime", "atom", "zed", "clipboard"],
  author: {
    name: "Toufiq Hasan Kiron",
    twitter: "https://twitter.com/hashtagkiron",
    email: "hello@kiron.dev",
    url: "https://kiron.dev",
    githubUrl: "https://github.com/kiron0",
    buyMeACoffeeUrl: "https://www.buymeacoffee.com/_thk",
  },
  url: "https://snippit.kiron.dev",
  ogImage: "/og-image.png",
  storageKey: `${name.toLowerCase()}-state`,
}
